/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import _ from 'lodash'
import { Form, Dimmer, Loader, Image, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import ImageUpload from '../../../services/ImageUpload'

const imageFileTypes = ['image/png', 'image/jpeg']

export default class LogoField extends React.Component {
  state = {
    bannerLoaded: false,
    compressing: false,
    uploading: false,
    displayBanner: null,
  }

  static getDerivedStateFromProps(props) {
    const { store } = props

    return { displayBanner: _.get(store, 'images.banner', null) }
  }

  onImageChange(e) {
    const file = e.target.files[0]

    if (file) {
      this.upload(file)
    }
  }

  onUploadClick = () => {
    this.imageInput.click()
  }

  validateFile = file => {
    const { type, size } = file
    let valid = true
    let message = ''

    if (!_.includes(imageFileTypes, type)) {
      valid = false
      message = 'Image file type can be accepted as PNG or JPEG.'
    } else if (size > 3000000) {
      valid = false
      message = 'Image file size can not bigger than 3Mb.'
    }

    return {
      valid,
      message,
    }
  }

  upload = async file => {
    const { storeId } = this.props

    try {
      const imageUpload = new ImageUpload(file, 'banner', {
        destination: `images/restaurants/${storeId}`,
        type: 'rest_banner',
        firebaseSavePath: `restaurants/${storeId}/images/compress_banner`,
        manipulation: {
          width: 640,
          height: 0,
          size: 15000,
        },
      })

      this.setState({ uploading: true })

      const { originalUrl } = await imageUpload.upload()

      this.setState({ uploading: false })
      this.saveBanner(originalUrl)
    } catch (err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  saveBanner = async downloadURL => {
    const { storeId, fetchStore } = this.props
    const updates = {}

    try {
      this.setState({ uploading: true })
      updates[`restaurants/${storeId}/images/banner`] = downloadURL

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ uploading: false, displayBanner: downloadURL })
      fetchStore()
    } catch (error) {
      this.setState({ uploading: false })
      alert(error.message || error)
    }
  }

  renderHasBanner = banner => {
    const { bannerLoaded } = this.state
    const { compressing, uploading } = this.state

    return (
      <div>
        <div style={{ width: 266, height: 150, position: 'relative' }}>
          <Image
            src={banner}
            style={{ width: 266, height: 150 }}
            onLoad={() => this.setState({ bannerLoaded: true })}
            onClick={this.onUploadClick}
          />
          {(compressing || uploading || !bannerLoaded) && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
        </div>
      </div>
    )
  }

  renderUploader = () => {
    const { compressing, uploading } = this.state

    return (
      <div onClick={this.onUploadClick} style={{ position: 'relative' }}>
        <div style={{ width: 266, height: 150 }}>
          <Image
            src={require('../../../assets/images/placeholder-480.png')}
            style={{ width: 266, height: 150 }}
          />
        </div>
        {(compressing || uploading) && (
          <Dimmer active>
            <Loader />
          </Dimmer>
        )}
      </div>
    )
  }

  render = () => {
    const { compressing, uploading, displayBanner } = this.state
    // const banner = _.get(store, 'images.banner', null)

    return (
      <div style={{ position: 'relative' }}>
        <Form.Field>
          <input
            hidden
            type="file"
            accept="image/*"
            onChange={e => this.onImageChange(e)}
            ref={input => {
              this.imageInput = input
            }}
          />
        </Form.Field>
        {displayBanner ? this.renderHasBanner(displayBanner) : this.renderUploader()}
        <div style={{ marginTop: 10 }}>
          <Button size="mini" onClick={this.onUploadClick} disabled={compressing || uploading}>
            {displayBanner ? 'Change' : 'Upload'}
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/bannerField.js